import React from 'react'
import { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { leadCapture, getUser } from '../Redux/Lead/leadCapture';
import TermsModal from './TermsModal';
import Swal from 'sweetalert2'
import './new.css'

function CalculatorModal({ showModal, setShowModal, handleCloseModal }) {
    const [openTermsModal, setOpenTermsModal] = useState(false)
    const dispatch = useDispatch();
    const { loading, error, lead } = useSelector((state) => state.lead)
    const formRef = useRef();
    const [planCount, setPlanCount] = useState(0);
    const [savings, setSavings] = useState(null);
    const [exampleText, setExampleText] = useState("");
    const navigate = useNavigate();

    const handlePlanCountChange = (e) => {
        const count = parseInt(e.target.value);
        setPlanCount(isNaN(count) ? 1 : count);
    };

    const handleFormSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const employees = parseInt(formData.get('employees'));
        const company = formData.get('company');
        const email = formData.get('email');
        const first_name = formData.get('firstName');
        const last_name = formData.get("lastName")
        const phone = formData.get("phone");
        const insuranceType = formData.get("insuranceType");
        const employer_contribution = formData.get("employerContribution")
        const employee_contribution = formData.get("employeeContribution")
        const interestedIn = formData.get("interest");

        const planCounts = [];
        for (let i = 1; i <= planCount; i++) {
            const count = parseInt(formData.get(`plan${i}Number`)) || 0;
            planCounts.push({
                name: `plan ${i}`,
                count: count
            });
        }

        const totalPlanMembers = planCounts.reduce((sum, plan) => sum + plan.count, 0);
        let calculated;

        if (parseInt(employees) < 125) {
            calculated = parseInt(employees) * 1000 * 12 * 0.3;
        }
        else {
            calculated = parseInt(employees) * 600;
        }

        const formatted = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 0,
        }).format(calculated);

        setSavings(formatted);
        setExampleText(`Example: (${employees} Employees) × (1000) × (12) - 70% = ${formatted}`);
        const obj = {
            number_of_employees: employees,
            company_name: company,
            email,
            first_name,
            last_name,
            phone,
            insurance: insuranceType,
            plans_offering: planCounts,
            savings: formatted,
            employer_contribution,
            employee_contribution,
            interestedIn,
            from : 'venturerev'
        }

        dispatch(leadCapture(obj)).then((action) => {
            if (action.payload.status == false) {
                Swal.fire({
                    icon: "error",
                    title: "Email Already Exists",
                    text: "Dear User, this email already exists in our system!",
                });
            }
            else {
                dispatch(getUser())
                handleCloseModal()

                if (parseInt(employees) >= 125) {
                    window.location.href = `https://weltriohealth.com/assessment-page-wh?company=${encodeURIComponent(company)}&savings=${encodeURIComponent(formatted)}&employees=${encodeURIComponent(employees)}`
                }
                else {
                    navigate('/assessment', { state: { company, employees, savings: formatted } })
                }
            }
        })
    };

    useEffect(() => {
        if (formRef.current) formRef.current.reset();
        const handleOutsideClick = (e) => {
            if (showModal && e.target.classList.contains('calculator-modal')) {
                handleCloseModal();
            }
        };

        if (showModal) {
            document.addEventListener('click', handleOutsideClick);
        }

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [showModal]);

    return (
        <div className="calculator-modal" style={{ display: showModal ? 'flex' : 'none' }}>
            <TermsModal open={openTermsModal} setOpen={setOpenTermsModal} />

            <div className="calculator-modal-content">
                <button
                    className="calculator-modal-close"
                    onClick={handleCloseModal}
                >
                    &times;
                </button>

                <h4 className="calculator-modal-header">
                    Healthcare Savings Calculator
                </h4>

                <form
                    id="insuranceForm"
                    onSubmit={handleFormSubmit}
                    disabled={loading}
                    ref={formRef}
                    className="calculator-form"
                >
                    <div className="calculator-form-grid">
                        <div className="calculator-form-group">
                            <label htmlFor="firstName" className="calculator-form-label">First Name:</label>
                            <input
                                type="text"
                                id="firstName"
                                name="firstName"
                                required
                                className="calculator-form-input"
                            />
                        </div>
                        <div className="calculator-form-group">
                            <label htmlFor="lastName" className="calculator-form-label">Last Name:</label>
                            <input
                                type="text"
                                id="lastName"
                                name="lastName"
                                required
                                className="calculator-form-input"
                            />
                        </div>

                        <div className="calculator-form-group">
                            <label htmlFor="email" className="calculator-form-label">Email Address:</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                required
                                className="calculator-form-input"
                            />
                        </div>

                        <div className="calculator-form-group">
                            <label htmlFor="phone" className="calculator-form-label">Phone Number:</label>
                            <input
                                type="tel"
                                id="phone"
                                name="phone"
                                className="calculator-form-input"
                            />
                        </div>

                        <div className="calculator-form-group">
                            <label htmlFor="company" className="calculator-form-label">Company Name:</label>
                            <input
                                type="text"
                                id="company"
                                name="company"
                                className="calculator-form-input"
                            />
                        </div>

                        <div className="calculator-form-group">
                            <label htmlFor="employees" className="calculator-form-label">Number Of Employees:</label>
                            <input
                                type="number"
                                id="employees"
                                name="employees"
                                min="1"
                                required
                                className="calculator-form-input"
                            />
                        </div>

                        <div className="calculator-form-group">
                            <label htmlFor="insuranceType" className="calculator-form-label">Are you self-insured or Fully Insured?</label>
                            <select
                                id="insuranceType"
                                name="insuranceType"
                                required
                                className="calculator-form-input"
                            >
                                <option value="">Select an option</option>
                                <option value="self-insured">Self-insured</option>
                                <option value="fully-insured">Fully Insured</option>
                                <option value="not-sure">Not Sure</option>
                            </select>
                        </div>

                        <div className="calculator-form-group">
                            <label htmlFor="planCount" className="calculator-form-label">How many health insurance plans do you offer?</label>
                            <select
                                id="planCount"
                                name="planCount"
                                required
                                onChange={handlePlanCountChange}
                                value={planCount}
                                className="calculator-form-input"
                            >
                                <option value="">Select number of plans</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                            </select>
                        </div>
                    </div>

                    <div className="calculator-plan-numbers">
                        {[...Array(planCount)].map((_, index) => (
                            <div key={`plan-number-${index}`} className="calculator-plan-item">
                                <label htmlFor={`plan${index + 1}Number`} className="calculator-form-label">Plan {index + 1}: (Family & Employees)</label>
                                <input
                                    type="number"
                                    id={`plan${index + 1}Number`}
                                    name={`plan${index + 1}Number`}
                                    required
                                    min="0"
                                    placeholder="Members Insured:"
                                    className="calculator-form-input"
                                    style={{ maxWidth: '90%' }}
                                />
                            </div>
                        ))}
                    </div>

                    <div className="calculator-form-grid">
                        <div className="calculator-form-group">
                            <label htmlFor="employerContribution" className="calculator-form-label">Employer Monthly Contribution:</label>
                            <input
                                type="text"
                                id="employerContribution"
                                name="employerContribution"
                                required
                                className="calculator-form-input"
                            />
                        </div>
                        <div className="calculator-form-group">
                            <label htmlFor="employeeContribution" className="calculator-form-label">Employee Monthly Contribution:</label>
                            <input
                                type="text"
                                id="employeeContribution"
                                name="employeeContribution"
                                required
                                className="calculator-form-input"
                            />
                        </div>

                        <div className="calculator-form-group">
                            <label htmlFor="insuranceType" className="calculator-form-label">I am most interested in:</label>
                            <select
                                id="option1"
                                name="interest"
                                required
                                className="calculator-form-input"
                            >
                                <option value="self-insured">Paying the lowest price possible for benefits</option>
                                <option value="fully-insured">Paying a little more for better benefits and employee retention</option>
                            </select>
                        </div>

                        <div className="calculator-checkbox-group">
                            <div style={{ display: 'flex', gap: '0.5rem' , justifyContent : 'center' }}>
                                <input
                                    type="checkbox"
                                    id="agreeTerms"
                                    name="agreeTerms"
                                    required
                                    style={{
                                        width: '3rem',
                                        height: '2rem',
                                    }}
                                />
                                <label htmlFor="agreeTerms" className="calculator-checkbox-label">
                                    I agree to <span onClick={() => setOpenTermsModal(true)} style={{ color: 'blue', cursor: 'pointer', textDecoration: 'underlined' }}>terms & conditions</span> and by providing my phone number, I consent to receive communications from VentureRev such as SMS, text messages, WhatsApp, emails.
                                </label>
                            </div>
                        </div>
                    </div>

                    <button
                        type="submit"
                        className="calculator-submit-btn"
                        disabled={loading}
                    >
                        {loading ? "Calculating..." : "Calculate Savings"}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default CalculatorModal